module.exports = {"TXTWCL_Deposit_Funds":{"id":"TXTWCL_Deposit_Funds","defaultMessage":"Déposer des fonds","track":"Deposit Funds"}}